/** **** Date Offset ******/
const isLastXDays = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const beginValue = addDays(currentDate, -offset);
  const endValue = addDays(currentDate, -1);
  return utcValue >= beginValue && utcValue <= endValue;
};

const isNextXDays = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const beginValue = addDays(currentDate, 1);
  const endValue = addDays(currentDate, offset);
  return utcValue >= beginValue && utcValue <= endValue;
};

const isLastXMonths = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const beginDate = addMonths(currentDate, -offset);
  const beginValue = getBeginValue(beginDate, beginDate.getMonth());
  const endDate = addMonths(currentDate, -1);
  const endValue = getEndValue(endDate, endDate.getMonth() + 1);
  return utcValue >= beginValue && utcValue <= endValue;
};

const isNextXMonths = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const beginDate = addMonths(currentDate, 1);
  const beginValue = getBeginValue(beginDate, beginDate.getMonth());
  const endDate = addMonths(currentDate, offset);
  const endValue = getEndValue(endDate, endDate.getMonth() + 1);
  return utcValue >= beginValue && utcValue <= endValue;
};

const isLastXYears = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const beginDate = addYears(currentDate, -offset);
  const beginValue = getBeginValue(beginDate, 0);
  const endDate = addYears(currentDate, -1);
  const endValue = getEndValue(endDate, 12);
  return utcValue >= beginValue && utcValue <= endValue;
};

const isNextXYears = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const beginDate = new Date(addYears(currentDate, 1));
  const beginValue = getBeginValue(beginDate, 0);
  const endDate = new Date(addYears(currentDate, offset));
  const endValue = getEndValue(endDate, 12);
  return utcValue >= beginValue && utcValue <= endValue;
};

const isLastXQuarters = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const quarterFirstDay = getQuarterFirstDay(currentDate);
  const beginValue = new Date(addQuarters(quarterFirstDay, -offset));
  const endValue = new Date(addDays(quarterFirstDay, -1));
  return utcValue >= beginValue && utcValue <= endValue;
};

const isNextXQuarters = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const quarterFirstDay = getQuarterFirstDay(currentDate);
  const beginValue = new Date(addQuarters(quarterFirstDay, 1));
  const quarterLastDay = new Date(addQuarters(beginValue, offset));
  const endValue = getEndValue(quarterLastDay, quarterLastDay.getMonth());
  return utcValue >= beginValue && utcValue <= endValue;
};

const isDateOffsetGreaterThan = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const offsetDate = addDays(new Date(currentDate), offset);
  return new Date(utcValue).getTime() > new Date(offsetDate).getTime();
};

const isDateOffsetLessThan = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const offsetDate = addDays(new Date(currentDate), offset);
  return new Date(utcValue).getTime() < new Date(offsetDate).getTime();
};

const isDateOffsetEquals = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const offsetDate = addDays(new Date(currentDate), offset);
  return new Date(utcValue).getTime() === new Date(offsetDate).getTime();
};

const isDateOffsetDoesNotEqual = (currentDate, offset, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const offsetDate = addDays(new Date(currentDate), offset);
  return new Date(utcValue).getTime() !== new Date(offsetDate).getTime();
};

/** **** Date Comparison ******/
const isGreaterThan = (conditonValue, fieldValue) => {
  return new Date(fieldValue).getTime() > new Date(conditonValue).getTime();
};

const isLessThan = (conditonValue, fieldValue) => {
  return new Date(fieldValue).getTime() < new Date(conditonValue).getTime();
};

const isEquals = (conditonValue, fieldValue) => {
  return new Date(fieldValue).getTime() === new Date(conditonValue).getTime();
};

const isDoesNotEqual = (conditonValue, fieldValue) => {
  return new Date(fieldValue).getTime() !== new Date(conditonValue).getTime();
};

/** **** Date Range ******/
const isBetween = (beginDate, endDate, fieldValue) => {
  const utcValue = setUtcHours(fieldValue);
  const utcBeginDate = setUtcHours(beginDate);
  const utcEndDate = setUtcHours(endDate);
  return utcValue >= utcBeginDate && utcValue <= utcEndDate;
};

/** **** Current Date ******/
const isCurrentDay = inputDate => {
  const localeInputDate = setUtcHours(inputDate);
  const localeCurrentDate = setUtcHours(new Date());
  return localeInputDate === localeCurrentDate;
};

const isCurrentMonth = inputDate => {
  const inputMonth = new Date(inputDate).getMonth();
  const currentMonth = new Date().getMonth();
  return _isCurrentYear(inputDate) && inputMonth === currentMonth;
};

const isCurrentQuarter = inputDate => {
  const inputQuarter = Math.floor((new Date(inputDate).getMonth() + 3) / 3);
  const currentQuarter = Math.floor((new Date().getMonth() + 3) / 3);
  return _isCurrentYear(inputDate) && inputQuarter === currentQuarter;
};

const isCurrentYear = inputDate => _isCurrentYear(inputDate);

const isAfterToday = inputDate => {
  const localeInputDate = setUtcHours(inputDate);
  const localeCurrentDate = setUtcHours(new Date());
  return localeInputDate > localeCurrentDate;
};

const isBeforeToday = inputDate => {
  const localeInputDate = setUtcHours(inputDate);
  const localeCurrentDate = setUtcHours(new Date());
  return localeInputDate < localeCurrentDate;
};

const _isCurrentYear = inputDate => {
  const inputYear = new Date(inputDate).getFullYear();
  const currentYear = new Date().getFullYear();
  return inputYear === currentYear;
};

const addDays = (date, offset) => {
  const value = new Date(date);
  value.setDate(value.getDate() + offset);
  return new Date(value.setUTCHours(0, 0, 0, 0));
};

const addMonths = (date, offset) => {
  const value = new Date(date);
  let month = value.getMonth();
  let year = value.getFullYear();

  month = (month + offset) % 12;
  if (month < 0) {
    year += (value.getMonth() + offset - month - 12) / 12;
    month += 12;
  } else year += (value.getMonth() + offset - month) / 12;

  value.setMonth(month);
  value.setFullYear(year);
  if (value.getDate() !== date.getDate()) {
    value.setDate(0);
  }
  return new Date(value.setUTCHours(0, 0, 0, 0));
};

const addYears = (date, offset) => {
  const value = new Date(date);
  value.setFullYear(value.getFullYear() + offset);
  return new Date(value.setUTCHours(0, 0, 0, 0));
};

const addQuarters = (date, offset) => {
  const value = new Date(date);
  const newValue = addMonths(value, offset * 3);
  return newValue;
};

const getQuarterFirstDay = dateValue => {
  const date = new Date(dateValue);
  const quarter = Math.floor(date.getMonth() / 3);
  date.setDate(1);
  date.setMonth(quarter * 3);
  date.setFullYear(date.getFullYear());
  return new Date(date);
};

const getBeginValue = (date, month) => {
  const value = new Date(date);
  value.setFullYear(date.getFullYear(), month, 1);
  return new Date(value);
};

const getEndValue = (date, month) => {
  const value = new Date(date);
  value.setFullYear(date.getFullYear(), month, 0);
  return new Date(value);
};

const setUtcHours = date => {
  return new Date(date).setUTCHours(0, 0, 0, 0);
};

module.exports = {
  isLastXDays,
  isNextXDays,
  isLastXMonths,
  isNextXMonths,
  isLastXYears,
  isNextXYears,
  isLastXQuarters,
  isNextXQuarters,
  isDateOffsetGreaterThan,
  isDateOffsetLessThan,
  isDateOffsetEquals,
  isDateOffsetDoesNotEqual,
  isGreaterThan,
  isLessThan,
  isEquals,
  isDoesNotEqual,
  isBetween,
  isCurrentDay,
  isCurrentMonth,
  isCurrentYear,
  isCurrentQuarter,
  isAfterToday,
  isBeforeToday,
  addDays,
  addMonths,
  addYears,
  addQuarters
};
